import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import ContentManager from '../../components/admin/ContentManager';

export default function JobsPage() {
  return (
    <AdminLayout>
      <ContentManager
        title="Jobs Management"
        subtitle="Manage job openings and vacancies"
        contentType="jobs"
        fields={[
          // Basic Information
          { name: 'title', label: 'Job Title', type: 'text', required: true },
          { name: 'department', label: 'Department', type: 'text', placeholder: 'e.g., ICAR-CISH' },
          { name: 'vacancies', label: 'No. of Vacancies', type: 'number', defaultValue: 1 },
          { name: 'employment_type', label: 'Employment Type', type: 'select', options: ['Contractual', 'Regular', 'Temporary', 'Other'], defaultValue: 'Contractual', required: true },
          { name: 'description', label: 'Job Description', type: 'richtext', hint: 'Detailed job description with formatting' },
          
          // Dates
          { name: 'post_date', label: 'Job Post Date', type: 'date' },
          { name: 'last_date', label: 'Last Date to Apply', type: 'date', required: true, hint: 'Job status computed automatically based on this date' },
          
          // Documents - File Upload
          { name: 'pdf_file', label: 'Job Notification PDF', type: 'file', fileType: 'pdf', hint: 'Upload job notification document' },
          { name: 'pdf_url', label: 'Or PDF URL', type: 'text', placeholder: 'External PDF link if not uploading' },
          
          { name: 'form_file', label: 'Application Form', type: 'file', fileType: 'document', hint: 'Upload application form (PDF/DOC)' },
          { name: 'form_file_url', label: 'Or Application Form URL', type: 'text', placeholder: 'External form link' },
          
          { name: 'result_file', label: 'Result PDF', type: 'file', fileType: 'pdf', hint: 'Upload result document when available' },
          { name: 'result_pdf_url', label: 'Or Result PDF URL', type: 'text', placeholder: 'External result link' },
          
          // Status
          { name: 'show_new', label: 'Show NEW Badge', type: 'checkbox', defaultValue: true, checkboxLabel: 'Display NEW badge (auto-hidden after last date)' },
          { name: 'is_active', label: 'Active', type: 'checkbox', defaultValue: true, checkboxLabel: 'Item is active' },
          { name: 'is_published', label: 'Published', type: 'checkbox', defaultValue: true, checkboxLabel: 'Visible to public' },
        ]}
        columns={['title', 'department', 'employment_type', 'last_date', 'is_published']}
      />
    </AdminLayout>
  );
}
